// extracted by mini-css-extract-plugin
export default {"fleetRisk":"carReport_fleetRisk__Vx0ny","searchBox":"carReport_searchBox__nrZBz"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"fleetRisk\":\"carReport_fleetRisk__Vx0ny\",\"searchBox\":\"carReport_searchBox__nrZBz\"}";
        // 1793842502691
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  